import { BaseModal, ModalResultType } from "../../modal/index";
import { Template, LazyTemplate } from "../../template/index";

export default class ErrorModal extends BaseModal
{
    public template = Template.lazy('/core/modals/error/index.html');

    constructor(displayError: Error, actualError: Error)
    {
        super();
        this.data.title = `Error: ${actualError.name}`;
        this.data.message = displayError.message;
        this.data.stackTrace = actualError.stack;
    }

    public afterRender(): PromiseLike<void>
    {
        this.element.querySelector('button.ok').addEventListener('click', e =>
        {
            this.close(ModalResultType.OK);
        });

        return super.afterRender();
    }
}